import { simpleFetch } from "./acCommon"

export const FETCHAFFILIATEMESSAGES_REQUEST = "FETCHAFFILIATEMESSAGES_REQUEST"
export const FETCHAFFILIATEMESSAGES_SUCCESS = "FETCHAFFILIATEMESSAGES_SUCCESS"
export const FETCHAFFILIATEMESSAGES_FAILURE = "FETCHAFFILIATEMESSAGES_FAILURE"

export const SUBMITAFFILIATEMESSAGE_REQUEST = "SUBMITAFFILIATEMESSAGE_REQUEST"
export const SUBMITAFFILIATEMESSAGE_SUCCESS = "SUBMITAFFILIATEMESSAGE_SUCCESS"
export const SUBMITAFFILIATEMESSAGE_FAILURE = "SUBMITAFFILIATEMESSAGE_FAILURE"

export const FETCHCONTRACTS_REQUEST = "FETCHCONTRACTS_REQUEST"
export const FETCHCONTRACTS_SUCCESS = "FETCHCONTRACTS_SUCCESS"
export const FETCHCONTRACTS_FAILURE = "FETCHCONTRACTS_FAILURE"

export const AFFILIATEMESSAGES_DATACHANGE = "AFFILIATEMESSAGES_DATACHANGE"
export const affiliateMessagesDataChange = changes => ({ type: AFFILIATEMESSAGES_DATACHANGE, changes })

export const USERAFFILIATE_METACHANGE = "USERAFFILIATE_METACHANGE"
export const userAffiliateMetaChange = changes => ({ type: USERAFFILIATE_METACHANGE, changes })

export const fetchAffiliateMessages = () => (dispatch, getState) => {
	let { selectedAffiliateID } = getState().metadataReducer.userAffiliate
	let init = { method: 'GET' }
	let url = "/customers/customer_contracts"
	dispatch(simpleFetch(url, init, 'FETCHCONTRACTS')).then(({ actionType, response }) => {
		if(actionType === FETCHCONTRACTS_SUCCESS){
			let contract = response.data.find(contract => contract.attributes.affiliate.data.id === selectedAffiliateID.toString())
			if(contract){
				let url = `/customers/customer_contracts/${contract.id}/messages`
				dispatch(simpleFetch(url, init, 'FETCHAFFILIATEMESSAGES'))
			}
		}
	})
}


export const submitAffiliateMessage = () => (dispatch, getState) => {
	let {
		dataReducer:     { allContracts, affiliateMessagesForm: { message } },
		metadataReducer: { userAffiliate: { selectedAffiliateID } }
	} = getState()
	let contractID = allContracts.find(contract => contract.affiliateID === selectedAffiliateID).id
	let init = { method: 'POST', body: JSON.stringify({ content: message }) }
	let url = `/customers/customer_contracts/${contractID}/messages`
	dispatch(simpleFetch(url, init, "SUBMITAFFILIATEMESSAGE"))
}



// WEBPACK FOOTER //
// ./src/actions/acUserAffiliate.js